import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITeamChatThread, ITeamChatMessage } from '../models/team-chat';
import { baseURL } from '../constants/base.url';
import { SocketService } from './socket.service'; // 👈 tumhari working socket service
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TeamChatService {
  constructor(private http: HttpClient, private socketService: SocketService) { }

  // ---- REST APIs ----
  openThread(participantIds: string[]): Observable<{ thread: ITeamChatThread }> {
    return this.http.post<{ thread: ITeamChatThread }>(`${baseURL}teamChat/threads`, { participantIds });
  }

  listThreads(): Observable<{ threads: ITeamChatThread[] }> {
    console.log('Calling API:', `${baseURL}teamChat/threads`);
    return this.http.get<any>(`${baseURL}teamChat/threads`).pipe(
      map(res => ({ threads: res.data?.threads || [] })) // 👈 map correct data path
    );
  }

  listMessages(threadId: string, limit = 30, before?: string): Observable<{ messages: ITeamChatMessage[]; nextCursor?: string }> {
    const params: any = { limit };
    if (before) params.before = before;
    return this.http.get<any>(`${baseURL}teamChat/threads/${threadId}/messages`, { params }).pipe(
      map(res => ({
        messages: res.data?.messages || [],
        nextCursor: res.data?.nextCursor
      }))
    );
  }

  sendMessage(threadId: string, text: string, targetUserId?: string, file?: File) {

    const formData = new FormData();
    formData.append('text', text || '');

    if (targetUserId) formData.append('targetUserId', targetUserId);
    if (file) formData.append('file', file);

    return this.http
      .post<any>(`${baseURL}teamChat/threads/${threadId}/messages`, formData)
      .pipe(
        map(res => ({
          thread: res.data.thread,
          message: res.data.message
        }))
      );

  }

  reactToMessage(messageId: string, reaction: string): Observable<ITeamChatMessage> {
    return this.http.post<ITeamChatMessage>(`${baseURL}teamChat/messages/${messageId}/react`, { reaction });
  }

  markThreadRead(threadId: string): Observable<ITeamChatThread> {
    return this.http.post<ITeamChatThread>(`${baseURL}teamChat/threads/${threadId}/read`, {});
  }

  toggleMute(threadId: string): Observable<ITeamChatThread> {
    return this.http.post<ITeamChatThread>(`${baseURL}teamChat/threads/${threadId}/toggle-mute`, {});
  }

  // ---- SOCKET ----
  joinThread(threadId: string) {
    this.socketService.emit('teamChat:join', { threadId });
  }

  leaveThread(threadId: string) {
    this.socketService.emit('teamChat:leave', { threadId });
  }

  onNewMessage(callback: (data: { threadId: string; message: ITeamChatMessage }) => void) {
    this.socketService.onEvent('teamChat:message:new').subscribe(callback);
  }

  onReaction(callback: (data: { messageId: string; reactions: any[] }) => void) {
    this.socketService.onEvent('teamChat:message:reaction').subscribe(callback);
  }

  onTyping(callback: (data: { threadId: string; userId: string; isTyping: boolean }) => void) {
    this.socketService.onEvent('teamChat:typing').subscribe(callback);
  }

  sendTyping(threadId: string, isTyping: boolean) {
    this.socketService.emit('teamChat:typing', { threadId, isTyping });
  }
}